module.exports = __webpack_public_path__ + "img/caret-up-dark.09f4cc31.svg";